document.addEventListener("DOMContentLoaded", function() {
  // Function to remove 'contenteditable' attribute from the element
  function removeContentEditable() {
    var reviewsMobileFilters = document.querySelector('.yotpo-score-filter[contenteditable="true"]')
    if (reviewsMobileFilters) {
      reviewsMobileFilters.removeAttribute('contenteditable')
      // Once the attribute is removed, clear the timer
      clearInterval(timer)
    }
  }
  // Set up a timer to check for the element every 500 milliseconds
  var timer = setInterval(removeContentEditable, 500)


})